module.exports = __webpack_public_path__ + "static/10-64bb94e39b5f52e18ba1106c056728ea.jpg";